import { useEmailTrackingApi } from "../api/EmailTrackingApiClient";
import { EmailTrackingFrontendService } from "../services/EmailTrackingFrontendService";

export const useEmailTrackingService = (): EmailTrackingFrontendService =>
  new EmailTrackingFrontendService(useEmailTrackingApi());
